module.exports = __webpack_public_path__ + "img/fwd.d83c20d3.png";